import { type Api, type UpdateCompanyInfoDto } from '@/api'
import { Member } from '@/model'
import { defineStore } from 'pinia'
import { computed, inject, ref } from 'vue'
import { useSiteStore } from './site'
import { HTTPError } from 'ky'
import { useCompanyStore } from './company'

export const useMemberStore = defineStore('memberStore', () => {
  const api = inject('exhibitorApi') as Api<unknown>

  const loginMember = ref<Member>(Member.Empty)
  const isForeigner = computed(() => loginMember.value.foreignFlag === 'Y')

  // index.twig 에서 loginMember가 삽입됨
  if (globalThis.initOptions.member !== null) {
    loginMember.value = new Member(globalThis.initOptions.member)
    delete globalThis.initOptions.member
  }

  async function login(loginId: string, password: string, rememberMe: boolean = false): Promise<string> {
    try {
      // 타임아웃 1분 설정
      const response = await api.member.loginCreate({ loginId, password, rememberMe })
      if (response.ok) {
        loginMember.value = new Member(response.data)
        return ''
      }

      if (response.status === 401) {
        return 'invalidCredentials'
      }

      return 'unknownLoginError'
    } catch (error: unknown) {
      if (error instanceof HTTPError) {
        if (error.response?.status === 401) {
          return 'invalidCredentials'
        }
      }

      return 'unknownLoginError'
    }
  }

  async function logout(goHome: boolean = true) {
    await api.member.logoutUpdate()
    localStorage.removeItem('currentFairId')
    loginMember.value = Member.Empty

    if (goHome) {
      const siteStore = useSiteStore()
      location.href = siteStore.siteConfig.basePath + '/login'
    }
  }

  async function updatePassword(currentPassword: string, newPassword: string): Promise<boolean> {
    try {
      await api.member.updatePasswordUpdate({
        currentPassword,
        newPassword
      })
      return true
    } catch (error: unknown) {
      console.log(error)

      return false
    }
  }

  async function updateCompanyInfo(companyData: UpdateCompanyInfoDto): Promise<void> {
    await api.member.updateCompanyInfoUpdate(companyData)

    loginMember.value = new Member(await api.member.myProfileList().then((res) => res.data))
    const companyStore = useCompanyStore()
    companyStore.initCompany()
  }

  return { loginMember, login, logout, isForeigner, updatePassword, updateCompanyInfo }
})
